/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import classNames from "classnames/bind";
import { number, object, arrayOf, string } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { FluidSections } from "../FluidSections";
import * as styles from "./PaginatedCollectionFluid.module.scss";

const cx = classNames.bind(styles);

const PaginatedCollectionFluid = ({ paginatedEntries, entriesPerPage, id, locale }) => {
	let currentIndex = 1;
	let currentButton = null;
	let prevButton = null;
	const minIndex = 1;
	let maxIndex = null;
	let groups = null;

	const parsedEntries = [];
	let groupHold = [];

	for (let i = 0; i < paginatedEntries.length; i++) {
		if (entriesPerPage !== 1) {
			groupHold.push(paginatedEntries[i]);
			if ((i !== 0 && (i + 1) % entriesPerPage === 0) || i === paginatedEntries.length - 1) {
				parsedEntries.push(groupHold);
				groupHold = [];
			}
		} else {
			parsedEntries.push([paginatedEntries[i]]);
		}
	}

	function displaySection(sectionIndex) {
		if (currentButton == null) {
			prevButton = document.getElementById(`pageButton1-${id}`);
		}

		const currentButtonID = `pageButton${sectionIndex}-${id}`;
		currentButton = document.getElementById(currentButtonID);

		if (currentButton) {
			if (prevButton !== null) {
				prevButton.style.borderColor = "#e2eff7";
			}
			currentButton.style.borderColor = "#ff6000";
			prevButton = currentButton;
		}

		if (!groups) {
			groups = document.getElementById(`groupsContainer${id}`).children;

			maxIndex = groups.length;
		}

		if (sectionIndex >= minIndex && sectionIndex <= maxIndex && sectionIndex !== currentIndex) {
			groups[currentIndex - 1].style.display = "none";

			currentIndex = sectionIndex;

			groups[currentIndex - 1].style.display = "flex";
		}
	}

	return (
		<div className={cx("paginatedCollectionContainer")}>
			{parsedEntries && (
				<div id={`groupsContainer${id}`} className={cx("entriesContainer")}>
					{parsedEntries.map((group, index) => (
						<div className={index === 0 ? cx("entriesGroup", "initialGroup") : cx("entriesGroup")}>
							{group.map(entry => (
								<FluidSections key={entry.id} data={entry} locale={locale} />
							))}
						</div>
					))}
				</div>
			)}

			<div className={cx("navButtonsContainer")}>
				<button className={cx("buttonClean")} type="button" onClick={() => displaySection(1)}>
					<i className="fas fa-angle-double-left" />
				</button>
				<button
					className={cx("navButton", "buttonClean")}
					type="button"
					onClick={() => displaySection(currentIndex - 1)}>
					<i className="fas fa-angle-left" />
				</button>

				{parsedEntries &&
					parsedEntries.map((group, index) => (
						<button
							id={`pageButton${index + 1}-${id}`}
							className={index === 0 ? cx("initialButton", "buttonClean") : cx("buttonClean")}
							type="button"
							onClick={() => displaySection(index + 1)}>
							{index + 1}
						</button>
					))}

				<button
					className={cx("buttonClean")}
					type="button"
					onClick={() => displaySection(currentIndex + 1)}>
					<i className="fas fa-angle-right" />
				</button>
				<button
					className={cx("buttonClean")}
					type="button"
					onClick={() => displaySection(parsedEntries.length)}>
					<i className="fas fa-angle-double-right" />
				</button>
			</div>
		</div>
	);
};

PaginatedCollectionFluid.propTypes = {
	paginatedEntries: arrayOf(object),
	entriesPerPage: number,
	id: string.isRequired,
	locale: string,
};
PaginatedCollectionFluid.defaultProps = {
	paginatedEntries: [],
	entriesPerPage: 1,
	locale: null,
};

export default PaginatedCollectionFluid;
export { PaginatedCollectionFluid };
